import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import QuickMessagePicker from '@Components/QuickMessagePicker';
import ShowFor from '@Components/ShowFor';
import { focusTextareaAt, insertAtCursor } from '@Utils/insertAtCursor';
import { useRef, useState } from 'react';
import { useMessages } from '../../contexts/messages';
import serviceMethods from '../../service';
import { ensurePhonePrefix } from '../../utils';
import { PLACEHOLDER_FISH_ID_PREFIX } from '../../utils/threadDisplay';
import './index.css';

const SMSThreadSendBox = ({ recipient, fishId, senderId, onAfterSend }) => {
  const { fetchSmsThread } = useMessages();
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);

  const textAreaRef = useRef(null);

  const handleSend = async () => {
    setSending(true);
    const trimmedText = text.trim();
    if (!trimmedText) return;
    const payload = {
      to: ensurePhonePrefix(recipient),
      body: trimmedText,
      fishId: fishId,
      senderId: senderId,
    };
    try {
      await serviceMethods.immediateSendSMS(payload);

      fetchSmsThread(recipient);
      setText('');
      if (textAreaRef.current) {
        textAreaRef.current.style.height = ''; // Back to its natural one-row height
      }

      // Call the onAfterSend callback if provided
      if (onAfterSend) {
        onAfterSend();
      }
    } catch (error) {
      console.error(error);
      toastError(error.message || 'Failed to update template');
    } finally {
      setSending(false);
    }
  };

  const handleQuickMessage = (message) => {
    const next = insertAtCursor(textAreaRef.current, text, message.messageBody);
    setText(next.value);
    focusTextareaAt(textAreaRef.current, next.caret);
  };

  return (
    <div className="flex items-end border-t border-gray-300 p-2">
      <ShowFor permissions={['MESSAGE_TEMPLATES_READ']}>
        <QuickMessagePicker
          channel="SMS"
          canResolveMergeTags={
            !!fishId && !String(fishId).startsWith(PLACEHOLDER_FISH_ID_PREFIX)
          }
          onSelect={handleQuickMessage}
        />
      </ShowFor>
      <textarea
        rows={1}
        placeholder="Type a message..."
        className="no-scrollbar max-h-[50vh] min-h-6 flex-1 resize-none overflow-y-auto border-none px-2 py-1 outline-none"
        ref={textAreaRef}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          // Auto-adjust height
          e.target.style.height = e.target.scrollHeight + 'px';
        }}
      />
      <Button onClick={handleSend} disabled={!text.trim()} loading={sending}>
        Send
      </Button>
    </div>
  );
};

export default SMSThreadSendBox;
